module.exports = __webpack_public_path__ + "media/images/about-us/USA-5c781cff17f2600d5cdd3229f1ade395.svg";